<div class="content-wrapper" [ngClass]="{'driver-mode': isDriverMode}">
  <button mat-flat-button (click)="navBack()" class="back-button">
    <mat-icon>arrow_back</mat-icon>
    Till startsidan
  </button>
  @if (booking && booking.bookingStatus !== 'CANCELLED') {
    <div class="handle">
      <button class="icon-button icon-button-edit" title="Redigera" (click)="editBooking()">
        <mat-icon>edit</mat-icon>
      </button>
      <button class="icon-button icon-button-delete" title="Radera" (click)="deleteBooking()">
        <mat-icon>delete</mat-icon>
      </button>
    </div>
  }

  @if (booking) {
    <section class="summary">
      <h2>
        <span>
          <mat-icon>directions_car</mat-icon>
          <span>{{ booking.registrationNumber }} {{booking.bookingStatus === 'CANCELLED' ? '- AVBOKAD' : ''}}</span>
        </span>
      </h2>
      @if (booking.vehicleType?.label || booking.engineType?.label) {
        <span class="car-type">
          <span class="connect-to-car"></span>
          {{booking.vehicleType?.label === 'SUV' ? 'SUV |' : ''}}
          {{booking.engineType?.label || ''}}
        </span>
      }
      @if (isDriverMode) {
        <div class="highlight-driver">
          <span class="chip" title="Betalningsstatus">
            <mat-icon>credit_card</mat-icon>
            <span [ngClass]="{ nopayment: !invoice && order?.paymentStatus?.paymentStatusId === 'UNPAID' }">{{ invoice ?
              'Faktura' :
            order?.paymentStatus?.label || 'okänt' }}</span>
          </span>
          <span class="chip" title="Plats">
            <mat-icon>place</mat-icon>
            <span>{{ booking.resource?.label }}</span>
          </span>
          <span class="chip" title="Resenärer">
            <mat-icon>people</mat-icon>
            <span>{{ booking.qtyPersons }}</span>
          </span>
          @if (hasCarwash) {
            <span class="chip" title="Tvätt">
              <mat-icon>local_car_wash</mat-icon>
              <span>Tvätt</span>
            </span>
          }
          @if (hasWorkshop) {
            <span class="chip" title="Verkstad">
              <mat-icon>build</mat-icon>
              <span>Verkstad</span>
            </span>
          }
          @if (hasCharging) {
            <span class="chip" title="Laddning">
              <mat-icon>bolt</mat-icon>
              <span>Laddning</span>
            </span>
          }
          @if (booking.boosterSeat) {
            <span class="chip" title="Bälteskudde">
              <mat-icon>child_care</mat-icon>
              <span>Bälteskudde</span>
            </span>
          }
          @if (booking.childSafetySeat) {
            <span class="chip" title="Bilbarnstol">
              <mat-icon>child_care</mat-icon>
              <span>Bilbarnstol</span>
            </span>
          }
          @if (booking.handLuggageOnly) {
            <span class="chip" title="Handbagage">
              <mat-icon>business_center</mat-icon>
              <span>Handbagage</span>
            </span>
          }
        </div>
      }
      @if (booking.comment && isDriverMode) {
        <div class="comment">
          <h4>Kommentar</h4>
          <p>{{ booking.comment }}</p>
        </div>
      }
      <div class="parking-and-flight-wrapper">
        <h4>Parkering starttid</h4>
        <div class="departure">
          <div class="date-wrapper">
            <span class="date">
              <mat-icon>event</mat-icon>
              <span>{{
                booking.departureDate
                ? formatDate(booking.departureDate)
                : 'datum ej tillgängligt'
                }}
              </span>
            </span>
            <span class="date">
              <mat-icon>access_time</mat-icon>
              <span>{{
                booking.departureDate ? formatTime(booking.departureDate) : '--:--'
              }}</span>
            </span>
          </div>
          <app-flight-information [flight]="booking.departureFlight" [flightInput]="booking.departureFlightNumber"
            [destination]="booking.departureFlight?.arrivalAirport" [travelHomeFrom]="undefined"
            [scheduledDate]="booking.departureFlight?.scheduledDepartureDate"
            [estimatedDate]="booking.departureFlight?.estimatedDepartureDate"
            [actualDate]="booking.departureFlight?.actualDepartureDate">
          </app-flight-information>
          <!-- Passenger status entry -->
          <div class="passenger-status-wrapper">
            <div class="entry-status">
              <mat-checkbox class="parking-entry-check" [formControl]="parkingEntryCheckbox" color="primary">
                <div class="label-flex-wrapper"><span>Anlänt P </span> <span class="datetime">{{booking.parkingEntry ?
                '(' + formatDate(booking.parkingEntry) + ' ' + formatTime(booking.parkingEntry) + ')' :
              ''}}</span>
              @if (booking.parkingEntryBy) {
<mat-icon title="Registrerats av {{booking.parkingEntryBy.name || 
                booking.parkingEntryBy.username ||
                 'okänt användare'}}">
                  person
                </mat-icon>
              }
            </div>
          </mat-checkbox>
        </div>
        <div class="passenger-status">
          <mat-checkbox [formControl]="droppedOffCheckbox" color="primary">Lämnade</mat-checkbox>
          @if (booking.qtyPersonsDroppedOff !== booking.qtyPersons && (booking.qtyPersonsDroppedOff || 0) > 0) {
            <span
              >{{booking.qtyPersonsDroppedOff}}
              /
              {{booking.qtyPersons}}
            </span>
          }
        </div>
      </div>
    </div>
    <h4>Parkering sluttid</h4>
    <div class="arrival">
      <div class="date-wrapper">
        <span class="date">
          <mat-icon>event</mat-icon>
          <span>{{
            booking.arrivalDate
            ? formatDate(booking.arrivalDate)
            : 'datum ej tillgängligt'
          }}</span>
        </span>
        <span class="date">
          <mat-icon>access_time</mat-icon>
          <span>{{
            booking.arrivalDate ? formatTime(booking.arrivalDate) : '--:--'
            }}
          </span>
        </span>
      </div>
      <app-flight-information [flight]="booking.arrivalFlight" [flightInput]="booking.arrivalFlightNumber"
        [travelHomeFrom]="booking.travelHomeFrom" [destination]="undefined"
        [scheduledDate]="booking.arrivalFlight?.scheduledArrivalDate"
        [estimatedDate]="booking.arrivalFlight?.estimatedArrivalDate"
        [actualDate]="booking.arrivalFlight?.actualArrivalDate">
      </app-flight-information>
      <!-- Passenger status exit -->
      <div class="passenger-status-wrapper">
        <div class="passenger-status">
          <mat-checkbox [formControl]="pickedUpCheckbox" color="primary">Hämtade</mat-checkbox>
          @if (booking.qtyPersonsPickedUp !== booking.qtyPersons
            && ((booking.qtyPersonsPickedUp || 0) > 0 )) {
            <span>
              {{booking.qtyPersonsPickedUp}} / {{booking.qtyPersons}}
            </span>
          }
        </div>
        <div class="entry-status">
          <mat-checkbox [formControl]="parkingExitCheckbox" color="primary">
            <div class="label-flex-wrapper">
              <span>Lämnat P </span>
              <span class="datetime">{{booking.parkingExit ?
                '(' + formatDate(booking.parkingExit) + ' ' + formatTime(booking.parkingExit) + ')' :
                ''}}
              </span>
              @if (booking.parkingExitBy) {
<mat-icon title="Registrerats av {{booking.parkingExitBy.name || 
                booking.parkingExitBy.username ||
                 'okänt användare'}}">
                  person
                </mat-icon>
              }
            </div>
          </mat-checkbox>
        </div>
      </div>
    </div>
  </div>
  @if (!isDriverMode) {
    <div class="highlight">
      <span title="Betalningsstatus">
        <mat-icon>credit_card</mat-icon>
        <span [ngClass]="{ nopayment: !invoice && order?.paymentStatus?.paymentStatusId === 'UNPAID' }">{{ invoice ?
          'Faktura' :
        order?.paymentStatus?.label || 'okänt' }}</span>
      </span>
      <span title="Plats">
        <mat-icon>place</mat-icon>
        <span>{{ booking.resource?.label }}</span>
      </span>
      <span title="Resenärer">
        <mat-icon>people</mat-icon>
        <span>{{ booking.qtyPersons }}</span>
      </span>
    </div>
  }
  @if (features?.length) {
    <div class="feature-section">
      <h4>Tillval</h4>
      <ul>
        @for (feature of features; track feature) {
          <li>
            <span> {{ feature.feature?.name }}</span>
            <span class="feature-amount">
            {{ feature.amount | number : '1.0-0' }} kr</span>
          </li>
        }
      </ul>
    </div>
  }
  @if (booking.comment && !isDriverMode) {
    <div class="comment">
      <h4>Kommentar</h4>
      <p>{{ booking.comment }}</p>
    </div>
  }
  @if (!isDriverMode) {
    <div class="bullet-items">
      <p>
        <span [ngClass]="{
          'mat-icon-bullet': true,
          inactive: booking.handLuggageOnly
        }">
          <mat-icon>
          {{!booking.handLuggageOnly ? 'checkmark' : 'close' }}</mat-icon>
        </span>
        <span>Incheckat bagage</span>
      </p>
      <p>
        <span [ngClass]="{
          'mat-icon-bullet': true,
          inactive: !booking.childSafetySeat
        }">
          <mat-icon>{{booking.childSafetySeat ? 'checkmark' : 'close'}}</mat-icon>
        </span>
        <span>Bilbarnstol</span>
      </p>
      <p>
        <span [ngClass]="{
          'mat-icon-bullet': true,
          inactive: !booking.boosterSeat
        }">
          <mat-icon>{{booking.boosterSeat ? 'checkmark' : 'close'}}</mat-icon>
        </span>
        <span>Bälteskudde</span>
      </p>
    </div>
  }
</section>
}

<!-- Booking information -->
@if (booking) {
  <section class="info-section">
    @if (!isCompactView) {
      <div>
        <h3>Bokningsinformation</h3>
        <ng-container *ngTemplateOutlet="bookingInformationContent"></ng-container>
      </div>
    } @else {
      <mat-accordion [multi]="true">
        <mat-expansion-panel class="mobile-info-panel">
          <mat-expansion-panel-header>
            <mat-panel-title>Bokningsinformation</mat-panel-title>
          </mat-expansion-panel-header>
          <ng-container *ngTemplateOutlet="bookingInformationContent"></ng-container>
        </mat-expansion-panel>
      </mat-accordion>
    }
    <mat-accordion [multi]="true">
      <!-- Order information -->
      @if (!isCompactView) {
        <div class="order-info">
          <h3>Orderinformation</h3>
          <ng-container *ngTemplateOutlet="orderInformationContent"></ng-container>
        </div>
      } @else {
        <mat-expansion-panel class="order-info mobile-info-panel">
          <mat-expansion-panel-header>
            <mat-panel-title>Orderinformation</mat-panel-title>
          </mat-expansion-panel-header>
          <ng-container *ngTemplateOutlet="orderInformationContent"></ng-container>
        </mat-expansion-panel>
      }
    </mat-accordion>
    <!-- Contact information -->
    @if (!isDriverMode) {
      <div>
        <h3>Kontaktinformation</h3>
        <ul>
          <li>
            <span> Namn: </span>
            <span class="value-to-end">{{ booking.name }}</span>
          </li>
          <li>
            <span> Telefonnummer: </span>
            <span class="value-to-end">{{ booking.phone }}</span>
          </li>
          <li>
            <span> E-post: </span>
            <span class="value-to-end">{{ booking.email }}</span>
          </li>
          <li>
            <span>Nyhetsbrev: </span>
            <span class="value-to-end">{{ booking.acceptNewsletter ? 'Ja' : 'Nej' }}</span>
          </li>
        </ul>
        <div class="email-button-wrapper">
          <button [ngClass]="{'button': true, 'slim': true, 'loading': loading}" [disabled]="isCancelled()"
            (click)="sendEmail()">
            Skicka bokningsbekräftelse
            @if (loading) {
              <mat-spinner diameter="25" color="accent"></mat-spinner>
            }
          </button>
          @if (emailMsg) {
            <p [ngClass]="{'success': emailSent, 'failed': !emailSent}">{{emailMsg}}</p>
          }
        </div>
      </div>
    }
    <ng-template #bookingInformationContent>
      <ul>
        <li>
          <span>Bokningsnummer: </span>
          <span class="value-to-end">{{ booking.qr }}</span>
        </li>
        <li>
          <span>Skapad:</span>
          <span class="value-to-end">{{ formatDate(booking.createdDate) || 'okänt' }}
            {{ formatTime(booking.createdDate) || '' }}
          </span>
        </li>
        <li>
          <span>Skapad av:</span>
          <span class="value-to-end">{{ booking.createdBy?.name || booking.createdBy?.username || 'okänt' }}</span>
        </li>
        <li>
          <span>Uppdaterad:</span>
          <span class="value-to-end">{{ formatDate(booking.updatedDate) || 'ej uppdaterad' }}
          {{ formatTime(booking.updatedDate) || '' }}</span>
        </li>
        <li>
          <span>Uppdaterad av:</span>
          <span class="value-to-end">
            {{ booking.updatedBy?.name || booking.updatedBy?.username || 'okänt' }}
          </span>
        </li>
        @if (booking.prepaidTicket) {
          <li>
            <span>Utnyttjat abonnemang: </span>
            <span class="value-to-end">{{ booking.prepaidTicket.name }} ({{
              booking.prepaidTicket.prepaidTicketId
            }})</span>
          </li>
        }
        <li>
          <span>Dynamisk prislista: </span>
          <button class="button slim" data-test="show-booking-pricelist" (click)="showPricelist()">
            Visa prislista
          </button>
        </li>
      </ul>
    </ng-template>
    <ng-template #orderInformationContent>
      @if (order) {
        <ul>
          <li>
            <span>Ordernummer: </span>
            @if (!isDriverMode) {
              <a (click)="showOrder(order.orderId)" class="value-to-end"><span>{{ order.orderId || '-' }}</span><mat-icon
            class="arrow">chevron_right</mat-icon></a>
          }
          @if (isDriverMode) {
            <span class="value-to-end">{{ order.orderId || '-' }}</span>
          }
        </li>
        <li>
          <span>Status: </span>
          <span class="value-to-end">
            {{!order.payments?.length &&
            order.orderStatus &&
            order.orderStatus !== 'COMPLETED' ? 'ORDER EJ BEHANDLAD. VÄLJ BETALNINGSMETOD.': 'Skapad'}}
          </span>
        </li>
        <li>
          <span>Betalningsmetod: </span>
          @if (!order.payments?.length) {
            <span class="value-to-end">
              Betala senare
            </span>
          }
          @for (payment of paymentMethods; track payment) {
            <span class="value-to-end">
              {{ payment }}
            </span>
          }
        </li>
        @if (invoice) {
          <li class="invoice-wrapper">
            <mat-expansion-panel>
              <mat-expansion-panel-header>
                <mat-panel-title>
                  <span>Fakturauppgifter</span>
                </mat-panel-title>
              </mat-expansion-panel-header>
              <ul>
                <li>
                  <span>Organisations-/personnummer: </span>
                  <span class="value-to-end">
                    {{invoice.organizationNumber}}
                  </span>
                </li>
                <li><span>Referens: </span><span class="value-to-end">{{ invoice.reference || '-' }}</span></li>
                <li><span>Namn: </span><span class="value-to-end">{{ invoice.name }}</span></li>
                <li><span>E-post kontakt: </span><span class="value-to-end">{{ invoice.email }}</span></li>
                <li><span>Telefonnummer: </span><span class="value-to-end">{{ invoice.phone }}</span></li>
                <li>
                  <span>E-faktura: </span>
                  <span class="value-to-end">{{ invoice.invoiceEmail || 'ingen' }}</span>
                </li>
                <li><span>Adress: </span><span class="value-to-end">{{ invoice.address }}</span></li>
                <li><span>Postnummer: </span><span class="value-to-end">{{ invoice.zip }}</span></li>
                <li><span>Stad: </span><span class="value-to-end">{{ invoice.city }}</span></li>
                <li><span>Land: </span><span class="value-to-end">{{ invoice.country }}</span></li>
              </ul>
            </mat-expansion-panel>
          </li>
        }
        @if (!invoice) {
          <li>
            <span> Betalningsstatus: </span>
            <span class="value-to-end">{{ order.paymentStatus?.label || 'okänt' }}</span>
          </li>
        }
        <li class="order-summary-title">Ordersummering:</li>
        <app-order-summary [order]="order" [currentBooking]="booking"
          [isDriverMode]="isDriverMode"
          [hasUnfinishedPayments]="(unfinishedPayments?.length || 0) > 0">
        </app-order-summary>
      </ul>
    }
  </ng-template>
</section>
}
</div>

<!-- Tabs history and parking events -->
<mat-tab-group mat-align-tabs="left" dynamicHeight="true" color="primary" class="tab-group" mat-stretch-tabs="false">
  <mat-tab label="Historik">
    <div class="history">
      <h3>Historik</h3>
      @if (!orderLog?.length) {
        <div class="empty-content">
          <p>Ingen historik</p>
        </div>
      }
      <app-history [historyLog]="orderLog"></app-history>
    </div>
  </mat-tab>

  <mat-tab label="Bompassering">
    <div class="parking-events">
      <h3>Bompassering</h3>
      @if (parkingEvents && parkingEvents.length > 0) {
        <app-entry-exit [parkingEvents]="parkingEvents">
        </app-entry-exit>
      }
      @if (!parkingEvents || parkingEvents.length < 1) {
        <div class="empty-content">
          Ingen bompassering har registrerats ännu
        </div>
      }
    </div>
  </mat-tab>
</mat-tab-group>